<div class="loyalty-container" [ngStyle]="{'opacity': isLoading ? '0.6' : '1' }" *ngIf="!tenant.SuppressLoyalty">
  <div class="flex-row-between">
    <div class="loyalty-header">
      <div class="loyalty-icon">
        <mat-icon>loyalty</mat-icon>
      </div>
      <span>Loyalty</span>
    </div>

    <div class="loyalty-points">
      You have {{ usersLoyaltyPoints }} pts (worth: £{{ pointsMonitoryValue(usersLoyaltyPoints) }})
    </div>
  </div>

  <div class="loader-container" *ngIf="isLoading; else content">
    <div class="lds-dual-ring"></div>
  </div>

  <ng-template #content>
    @if (redeemablePointsList.length) {
      <div class="loyalty-discount">
        <div class="discount-amount">
          £{{ pointsMonitoryValue(redeemablePointsList[0]) }} discount
        </div>
        <button class="redeem-btn"
                id="redeem-loyalty-button"
                [disabled]="errorMessage || totalIsLessThanMinimumSpendError"
                (click)="redeemLoyalty(redeemablePointsList[0])">
          <span>{{ redeemablePointsList[0] }}pts</span>
          <div class="divider"></div>
          <div class="flex-center" style="font-weight: bold;">
            REDEEM
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </button>
      </div>

      @if (isExpanded) {
        <div class="expanded-list">
          <div class="loyalty-items">
            @for (redeemablePoints of redeemablePointsList; track $index) {
              @if ($index > 0) {
                <div class="loyalty-discount">
                  <div class="discount-amount">
                    £{{ pointsMonitoryValue(redeemablePoints) }} discount
                  </div>
                  <button class="redeem-btn"
                          id="redeem-loyalty-button"
                          [disabled]="errorMessage || totalIsLessThanMinimumSpendError"
                          (click)="redeemLoyalty(redeemablePoints)">
                    <span>{{ redeemablePoints }}pts</span>
                    <div class="divider"></div>
                    <div class="flex-center" style="font-weight: bold;">
                      REDEEM
                      <mat-icon>arrow_forward</mat-icon>
                    </div>
                  </button>
                </div>
              }
            }
          </div>
        </div>
      }

      @if (redeemablePointsList.length > 1) {
      <div class="view-toggle-container">
        <button class="view-toggle-btn" (click)="toggleExpand()">
          <div class="view-toggle-content">
            <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            <span>{{ isExpanded ? 'View Less' : 'View More' }}</span>
          </div>
        </button>
      </div>
      }
    }

    <span class="error-message" *ngIf="!totalIsLessThanMinimumSpendError && errorMessage">
      {{ errorMessage }}
    </span>

    <span class="error-message" *ngIf="totalIsLessThanMinimumSpendError">
      {{ totalIsLessThanMinimumSpendError }}
    </span>

    @if (pointsToReachMin > 0) {
      <span class="points-needed">
        You need {{pointsToReachMin}} more loyalty points to be eligible for {{discountValue}} discount.
      </span>
    }

    <span class="earnable-points" *ngIf="basket?.LoyaltyPointsValue && !orderComplete && showEarnableLoyaltyPoints()">
      You could earn {{ earnablePointsForCurrentBasket }} loyalty points when completing this order.
    </span>
  </ng-template>
</div>

<ng-template #confirmWantedTime>
  <app-wanted-time-picker [basket]="basket"
                          [site]="currentSite"
                          (onWantedTimeUpdated)="redeemLoyalty()"></app-wanted-time-picker>
</ng-template>
